import { FileUploadOutput } from '@zonofi/common';
import { v4 as uuidv4 } from 'uuid';

export const uploader = async ({
  type = '*/*',
  multiple = false,
  maxFileSize,
}: {
  type?: string;
  multiple?: boolean;
  maxFileSize?: number;
}) => {
  const input = document.createElement('input');
  input.style.display = 'none';
  input.setAttribute('type', 'file');
  input.setAttribute('accept', type);
  input.setAttribute('id', uuidv4());
  if (multiple) {
    input.setAttribute('multiple', 'multiple');
  }

  const readFileAsArrayBuffer = (file: File) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      //@ts-ignore
      reader.onload = (e) => resolve(e.target.result);
      reader.readAsArrayBuffer(file);
    });
  };

  document.body.appendChild(input);
  return new Promise<{
    type: string;
    error?: string;
    output?: FileUploadOutput[];
  }>((resolve, reject) => {
    input.addEventListener('change', () => {
      const finalData: FileUploadOutput[] = [];
      if (input.files) {
        const files = Array.from(input.files); // Convert FileList to array
        if (maxFileSize !== undefined) {
          const oversizedFiles = files.filter(
            (file) => file.size > maxFileSize
          );
          if (oversizedFiles.length > 0) {
            resolve({
              type: 'error',
              error: `Some files exceed the maximum size of ${maxFileSize} bytes`,
            });
            document.body.removeChild(input);
            return;
          }
        }
        const processFile = (index: number) => {
          if (index < files.length) {
            const reader = new FileReader();

            reader.onerror = (error) => {
              console.error('Error reading file:', error);
              reject(
                new Error(
                  'Failed to read the selected media because the operation failed.'
                )
              );
            };

            reader.onload = async ({ target }) => {
              if (target) {
                const uri = target.result as string;
                const targetFile = files[index];

                const data = await readFileAsArrayBuffer(targetFile);

                finalData[index] = {
                  uri,
                  data: data,
                  name: targetFile.name,
                  file: targetFile,
                  lastModified: targetFile.lastModified,
                  size: targetFile.size,
                };

                processFile(index + 1);
              }
            };

            reader.readAsDataURL(files[index]);
          } else {
            resolve({
              type: 'success',
              output: finalData,
            });
            document.body.removeChild(input);
          }
        };

        processFile(0);
      } else {
        resolve({ type: 'cancel' });
        document.body.removeChild(input);
      }
    });

    const event = new MouseEvent('click');
    input.dispatchEvent(event);
  });
};
